import { createContext, useContext, useState, useEffect } from "react";
import api from "../utils/api.js";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = sessionStorage.getItem("user");
    const token  = sessionStorage.getItem("token");
    if (stored && token) {
      setUser(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const register = async (name, email, password) => {
  const { data } = await api.post("/auth/register", { name, email, password });
  const newUser = { ...data.user, role: (data.user?.role || '').toLowerCase() };
  sessionStorage.setItem("token", data.token);
  sessionStorage.setItem("user", JSON.stringify(newUser));
  setUser(newUser);
  return newUser;
};

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    const user = { ...data.user, role: (data.user?.role || '').toLowerCase() };
    sessionStorage.setItem("token", data.token);
    sessionStorage.setItem("user",  JSON.stringify(user));
    setUser(user);
    return user;
  };

  const loginAsDemoReporter = () => {
    const demoUser = {
      id: 999,
      name: 'Anil Sharma',
      email: 'reporter@bholikoitahari.com',
      role: 'reporter',
    };
    sessionStorage.setItem('token', 'demo-token-reporter');
    sessionStorage.setItem('user', JSON.stringify(demoUser));
    setUser(demoUser);
    return demoUser;
  };

  const logout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    setUser(null);
  };

 
  const updateUser = (updatedUser) => {
    const merged = { ...user, ...updatedUser };
    sessionStorage.setItem("user", JSON.stringify(merged));
    setUser(merged);
  };

  const isAdmin = user?.role === "admin";
  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, loading, login, register, loginAsDemoReporter, logout, updateUser, isAdmin, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
};